module.exports = __webpack_public_path__ + "static/img/ksrk_logo6.5f48765.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/官网首页/firstlink/ksrk_logo6.png
// module id = jxKa
// module chunks = 1